module.exports = __webpack_public_path__ + "img/m_logo.dd61cfff.png";